import { inject } from '@angular/core';
import { LayoutService } from '../components/layout/layout.service';
import { CanDeactivateFn } from '@angular/router';

export const confirmProfileGuard: CanDeactivateFn<unknown> = (_component, _route, _state, nextState) => {
  const layoutService = inject(LayoutService);
  const isLogout = nextState.root.queryParams['logout'] === 'true';
  
  return isLogout || layoutService.linksEnabled();
};
